
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const useBreadcrumbs = () => {
  const { modules } = useSelector(state => state.auth);
  const { pathname } = useLocation();

  for (let key in modules) {
    for (let module of modules[key]) {
      if (pathname.startsWith(module.route)) {
        return [
          { label: key },
          { label: module.name }
        ];
      }
    }
  }
  return [];
};
